export const FINAL_VOICEOVER_MODE_OPTIONS = [
  { label: '直接验收当前成片声音', value: 'keep_current_audio' },
  { label: 'AI 旁白配音后再交付', value: 'ai_voiceover' },
  { label: '人工配音/混音终版', value: 'manual_dub' },
] as const

export const FINAL_VOICEOVER_TONE_OPTIONS = [
  { label: '冷静克制', value: 'calm' },
  { label: '情绪推进', value: 'dramatic' },
  { label: '品牌讲述', value: 'brand' },
  { label: '剧情沉浸', value: 'immersive' },
] as const

export const FINAL_BGM_PLAN_OPTIONS = [
  { label: '保留当前声音，不额外加 BGM', value: 'keep_current' },
  { label: '轻氛围 BGM + 少量音效', value: 'light_bgm' },
  { label: '戏剧增强型 BGM + 节点音效', value: 'dramatic_bgm' },
  { label: '人工后期统一处理', value: 'manual_post' },
] as const

export function normalizeSceneVideoDuration(value: unknown, fallback = 5) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) {
    return fallback
  }
  return Math.min(15, Math.max(2, Math.round(numeric)))
}

export function resolveSceneVideoDuration(scene?: Record<string, any> | null) {
  return normalizeSceneVideoDuration(scene?.duration ?? scene?.estimated_duration ?? 5, 5)
}

export function formatSceneVideoTaskStatus(status: string) {
  const normalized = String(status || '').trim().toLowerCase()
  if (normalized === 'queued') return '排队中'
  if (normalized === 'running') return '生成中'
  if (normalized === 'succeeded') return '已生成'
  if (normalized === 'failed') return '生成失败'
  if (normalized === 'cancelled') return '已取消'
  return '未开始'
}

export function buildSceneVideoTaskDescription(task?: Record<string, any> | null) {
  const status = String(task?.status || '').trim().toLowerCase()
  if (status === 'queued') {
    return '镜头图片和提示词已经提交成功，系统正在排队等待视频模型处理。'
  }
  if (status === 'running') {
    return '视频模型已经开始生成，完成后会自动回填当前镜头，并同步归档到素材中心。'
  }
  if (status === 'succeeded') {
    return '当前镜头视频已经生成完成，可以直接预览、下载，或继续上传人工修订版本。'
  }
  if (status === 'failed') {
    return String(task?.error || '这次任务没有成功完成，你可以修改提示词后重新生成。')
  }
  return '当前镜头还没有正在执行的视频生成任务。'
}

export function buildSceneVideoTaskTimeline(task?: Record<string, any> | null) {
  const status = String(task?.status || '').trim().toLowerCase()
  const submittedState = task ? 'completed' : 'pending'
  const runningState = status === 'running' ? 'active' : (status === 'succeeded' || status === 'failed' || status === 'cancelled' ? 'completed' : 'pending')
  const finishedState = status === 'succeeded' ? 'completed' : (status === 'failed' || status === 'cancelled' ? 'active' : 'pending')

  return [
    { label: '任务提交', state: submittedState },
    { label: '模型生成', state: runningState },
    { label: '结果回填', state: finishedState },
  ]
}